@import (reference) '../../../../../constants/spacing.module.less';

.dropdown-container {
  align-items: baseline;
  column-gap: @space-32;
}

.dropdown-wrapper {
  flex: 1;
}

.dropdown-label {
  font-size: 16px;
  margin-bottom: @space-4;
}
